(() => {
  const productRoot = () => window.Shopify?.routes?.root || '/';
  function enquiryURL(block, variant) {
    const url = new URL(block.dataset.contactUrl, window.location.origin);
    url.searchParams.set('product', block.dataset.productHandle);
    url.searchParams.set('product_name', block.dataset.productName);
    url.searchParams.set('variant', String(variant.id));
    url.searchParams.set('option', variant.title || '');
    url.searchParams.set('sku', variant.sku || '');
    url.hash = 'product-enquiry';
    return url;
  }
  function variants(block) {
    return Array.from(block.querySelectorAll('[data-vg-enquiry-variant]'), (item) => item.dataset);
  }
  document.addEventListener('product:variant-change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    document.querySelectorAll('[data-vg-product-enquiry]').forEach((block) => {
      if (!variants(block).some((item) => String(item.id) === String(variant.id))) return;
      block.querySelector('[data-vg-enquiry-link]').href = enquiryURL(block, variant).href;
    });
  });
  document.addEventListener('submit', (event) => {
    const block = event.target.querySelector('[data-vg-product-enquiry]');
    if (!block || !event.target.matches('[data-product-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(block.querySelector('[data-vg-enquiry-link]').href);
  }, true);

  async function initContact() {
    const panel = document.querySelector('[data-vg-enquiry-form]');
    if (!panel) return;
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('product');
    if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return;
    const variantId = params.get('variant') || params.get('id') || '';
    panel.hidden = false;
    const general = document.querySelector('[data-vg-general-contact]');
    if (general) general.hidden = true;
    const productURL = new URL(`${productRoot()}products/${encodeURIComponent(handle)}`, window.location.origin);
    if (/^\d+$/.test(variantId)) productURL.searchParams.set('variant', variantId);
    const context = {
      text: params.get('product_name') || handle,
      'text-1': params.get('option') === 'Default Title' ? '' : params.get('option') || '',
      'text-2': params.get('sku') || '',
      'text-3': productURL.href,
      'text-4': /^\d+$/.test(variantId) ? variantId : ''
    };
    const updateSummary = () => {
      panel.querySelector('[data-vg-enquiry-product-title]').textContent = context.text;
      panel.querySelector('[data-vg-enquiry-option]').textContent = context['text-1'];
      panel.querySelector('[data-vg-enquiry-option-wrapper]').hidden = !context['text-1'];
      panel.querySelector('[data-vg-enquiry-sku-label]').textContent = context['text-2'];
      panel.querySelector('[data-vg-enquiry-product-link]').href = context['text-3'];
    };
    const syncFields = () => {
      for (const [key, value] of Object.entries(context)) {
        const input = panel.querySelector(`[id="167954-${key}"]`);
        if (!input) continue;
        input.readOnly = true;
        const row = input.closest('.globo-form-control');
        if (row) row.classList.add('vg-enquiry-metadata');
        if (input.value === value) continue;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const postcode = panel.querySelector('[id="167954-number"]');
      if (postcode) {
        const installation = panel.querySelector('[id="167954-select"]')?.value === 'Supply and installation';
        postcode.type = 'text';
        postcode.inputMode = 'numeric';
        postcode.pattern = '[0-9]{4}';
        postcode.maxLength = 4;
        postcode.required = installation;
        postcode.disabled = !installation;
        postcode.setCustomValidity('');
      }
    };
    panel.addEventListener('change', (event) => {
      if (event.target.id === '167954-select') syncFields();
    });
    panel.addEventListener('submit', (event) => {
      const postcode = panel.querySelector('[id="167954-number"]');
      if (postcode?.required && !/^[0-9]{4}$/.test(postcode.value)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        postcode.reportValidity();
      }
    }, true);
    updateSummary();
    const host = panel.querySelector('[data-vg-globo-product-contact]');
    if (host) new MutationObserver(syncFields).observe(host, { childList: true, subtree: true });
    syncFields();
    if (window.location.hash === '#product-enquiry') panel.scrollIntoView({ block: 'start' });
    try {
      const response = await fetch(`${productRoot()}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const product = await response.json();
      const variant = product.variants?.find((item) => String(item.id) === variantId);
      context.text = product.title;
      if (variant) {
        context['text-1'] = variant.title === 'Default Title' ? '' : variant.title;
        context['text-2'] = variant.sku || '';
        context['text-4'] = String(variant.id);
      }
      updateSummary();
      syncFields();
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initContact, { once: true });
  else initContact();
})();
